import React, { Component } from 'react';
import firebase from 'firebase';
import withAuthorization from '../Session/withAuthorization';
import { compose } from 'recompose';
import '../css/forms.css';
import '../css/main.css';
 
 

class ChatAdmin extends Component {
    constructor(props){
        super(props);
        this.state = {
            tableData : []
        }
    }

    componentDidMount(){
        var self = this
        firebase.database().ref('users/admin/messages').on('value',function(snap){
            var temp = snap.val() , data = [];
            self.setState({
                tableData : temp
            }) 
        })
    }

    render(){
        console.log(this.state.tableData)
        var temp = this.state.tableData ,self = this
        return(
            <div style={{display: 'flex' , flexDirection: 'column'}}>
                <div className="display_home" style={{display: 'flex' , flexDirection: 'column'}}>
                {
                    Object.keys(temp).map(key =>{
                        return(
                            <div className="col-lg-6 card_details" style={{justifyContent : 'flex-start' , textAlign : 'left'}}>
                                <p style={{color : "#F2994A"}}>Message recieved from - <span style={{textTransform : 'capitalize' , color : '#323545' ,fontSize : '16px' , fontWeight : '500' }}>{temp[key].From}</span></p>
                                <p style={{color : "#F2994A" , display: 'flex'}}>Message - <span style={{fontSize : '16px' , fontWeight : '500' ,color : '#323545' ,  wordBreak : 'break-word' }}>{temp[key].Msg} </span></p>
                            </div>
                        )
                    })
                }
                </div>
            </div>
        )
    }

}

const authCondition = (authUser) => !!authUser;

export default compose(withAuthorization(authCondition))(ChatAdmin);